<template>
  <div class="page">
    <div class="page-header">
      <slot name="header"></slot>
    </div>

    <div class="page-main">
      <div class="page-main-scroll">
        <slot></slot>
      </div>
    </div>

    <div
      class="page-footer"
      :style="{ paddingBottom: safeAreaBottom }"
    >
      <slot name="footer"></slot>
    </div>

    <div class="page-global">
      <slot name="global"></slot>
    </div>
  </div>
</template>

<style scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.page-header {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
}
.page-footer {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
}
.page-main {
  position: relative;
  z-index: 2;
  flex: 1 1 auto;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.page-main-scroll {
  position: relative;
  z-index: 3;
  flex: 1 1 auto;
  width: 100%;
  overflow-y: scroll;
}
/*
.page-main-scroll > :nth-child(1) {
  min-height: 100%;
}
*/
</style>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { useSafeArea$ } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const safeAreaBottom = ref("0px");
let s;

onMounted(() => {
  s = useSafeArea$().subscribe((s) => {
    safeAreaBottom.value = s.bottom;
  });
});
onUnmounted(() => {
  s?.unsubscribe();
});

defineExpose({});
</script>
